export const factory = (as) => ({
  as: Comp = as,
  ...rest
}) => <Comp {...rest} />

const ComponentFromProp = factory('div')

export default ComponentFromProp



// WEBPACK FOOTER //
// ./components/component-from-prop.js